let firstAppDaysValues = [];
let firstInterviewDaysValues = [];
let firstOfferDaysValues = [];
let firstAcceptedDaysValues = [];

let averageDaysToFirstApplication = 0;
let averageDaysFromApplicationToFirstInterview = 0;
let averageDaysFromInterviewToFirstOffer = 0;
let averageDaysFromOfferToFirstOfferAccepted = 0;

const resetValues = () => {
  firstAppDaysValues = [];
  firstInterviewDaysValues = [];
  firstOfferDaysValues = [];
  firstAcceptedDaysValues = [];

  averageDaysToFirstApplication = 0;
  averageDaysFromApplicationToFirstInterview = 0;
  averageDaysFromInterviewToFirstOffer = 0;
  averageDaysFromOfferToFirstOfferAccepted = 0;
};

const averageDays = (arrayOfDays: Array<number>) => {
  const sum = arrayOfDays.reduce((total, days) => total + days, 0.0);

  return parseFloat((sum / arrayOfDays.length).toFixed(1)) || 0;
};

interface ITimeToHireAttributeHash {
  days: number;
  percent: number;
}

const timeToHireAttributeHash = (days: number): ITimeToHireAttributeHash => ({
  days,
  percent: 25,
});

interface IUnstructuredTimelineData {
  daysToFirstApplication: number;
  daysFromApplicationToFirstInterview: number;
  daysFromInterviewToFirstOffer: number;
  daysFromOfferToFirstOfferAccepted: number;
}

const collectDateDifferences = (
  unstructuredTimelineData: Array<IUnstructuredTimelineData>
): void => {
  unstructuredTimelineData.forEach((timeline: IUnstructuredTimelineData) => {
    firstAppDaysValues.push(timeline.daysToFirstApplication);
    firstInterviewDaysValues.push(timeline.daysFromApplicationToFirstInterview);
    firstOfferDaysValues.push(timeline.daysFromInterviewToFirstOffer);
    firstAcceptedDaysValues.push(timeline.daysFromOfferToFirstOfferAccepted);
  });
};

const calculateAverageDays = () => {
  averageDaysToFirstApplication = averageDays(firstAppDaysValues);
  averageDaysFromApplicationToFirstInterview = averageDays(
    firstInterviewDaysValues
  );
  averageDaysFromInterviewToFirstOffer = averageDays(firstOfferDaysValues);
  averageDaysFromOfferToFirstOfferAccepted = averageDays(
    firstAcceptedDaysValues
  );
};

const formatTotalTimeToHire = (days: number): string => {
  const num = parseFloat(days.toFixed(1));
  if (num < 1) {
    return "Less than one day";
  }
  if (num === 1) {
    return "One day";
  }
  return `${num} days`;
};

export interface IApplicationTrackingData {
  timeToHireTotalDays: string;
  timeToHire: {
    applicationsReceived: ITimeToHireAttributeHash;
    interviewProcess: ITimeToHireAttributeHash;
    offerMade: ITimeToHireAttributeHash;
    offerAccepted: ITimeToHireAttributeHash;
  };
}

const applicationActionTrackingData = (
  unstructuredTimelineData: Array<IUnstructuredTimelineData>
): IApplicationTrackingData => {
  resetValues();
  collectDateDifferences(unstructuredTimelineData);
  calculateAverageDays();

  const totalDaysToHire =
    averageDaysToFirstApplication +
    averageDaysFromApplicationToFirstInterview +
    averageDaysFromInterviewToFirstOffer +
    averageDaysFromOfferToFirstOfferAccepted;

  const totalTimeToHire = formatTotalTimeToHire(totalDaysToHire);

  return {
    timeToHireTotalDays: totalTimeToHire,
    timeToHire: {
      applicationsReceived: timeToHireAttributeHash(
        averageDaysToFirstApplication
      ),
      interviewProcess: timeToHireAttributeHash(
        averageDaysFromApplicationToFirstInterview
      ),
      offerMade: timeToHireAttributeHash(averageDaysFromInterviewToFirstOffer),
      offerAccepted: timeToHireAttributeHash(
        averageDaysFromOfferToFirstOfferAccepted
      ),
    },
  };
};

export default applicationActionTrackingData;
